module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-删除活动标签-常规.d9801.png";